import Dto from "../../../../../../service/Dto";

class SendOutput extends Dto {

  constructor(_class = 'campaign\\module\\modules\\omsModule\\v001\\service\\dto\\SendOutput') {
    super(_class);
  }
}

export default SendOutput;
